import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {VacantBedComponent} from './vacant-bed.component';

const routes: Routes = [
  {
    path: '', component: VacantBedComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/bed-management/under-maintenance/vacant-bed/vacent-bed.routing.ts